/**
 * --------------------------------------------------
 * Listener for email input on cta email combo block
 * 
 * @module email-input
 * @see module:email-input
 * --------------------------------------------------
 */

export default {
    $emailInput: null,
    $marketoEmailInput: null,
    _emailValue: '',

    setup: function () {
        this.$emailInput = $('.rt-js-email-input');
        this.$marketoEmailInput = $('#global-modal').find('input[type="email"]');

        // Validate if email input exists
        // if not exit the function
        if(this.$emailInput.length === 0) return;

        // Start listeners
        this._listeners();
    },

    // Listen, listen, listen
    _listeners: function() {
        const _self = this;
        // Listen for input changes on all .rt-js-email-input fields
        this.$emailInput.on('input', (event) => {
            _self._emailValue = event.target.value;
            _self._updateMarketoEmailField();
        });
    },

    // Update the Marketo email field with the current email value
    _updateMarketoEmailField: function() {
        this.$marketoEmailInput.val(this._emailValue);
        this.$emailInput.val(this._emailValue);
    }
}